import { render } from "./PopularMovies.vue?vue&type=template&id=80d95a24"
import script from "./PopularMovies.vue?vue&type=script&lang=js"
export * from "./PopularMovies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__